function FooterPrimary() {
    return (
        <>

            <div className="web-footer-primary">
                <div className="web-footer-primary__container container">
                    <div className="web-footer-primary__column">
                        <h4>About</h4>
                        <ul>
                            <li><a href="https://google.com">About The Library</a></li>
                            <li><a href="https://google.com">Press</a></li>
                            <li><a href="https://google.com">Our blog</a></li>
                            <li><a href="https://google.com">Join our team !</a></li>
                            <li><a href="https://google.com">Contact us</a></li>
                            <li><a href="https://google.com">Invite friends</a></li>
                            <li><a href="https://google.com">Gifts</a></li>
                            <li><a href="https://google.com">Library for enterprise</a></li>
                        </ul>
                    </div>

                    <div className="web-footer-primary__column">
                        <h4>Support</h4>
                        <ul>
                            <li><a href="https://google.com">Help / FAQ </a></li>
                            <li><a href="https://google.com">Accessibility</a></li>
                            <li><a href="https://google.com">Purchase help</a></li>
                            <li><a href="https://google.com">AdChoice</a></li>
                            <li><a href="https://google.com">Publishers</a></li>
                        </ul>
                    </div>

                    <div className="web-footer-primary__column">
                        <h4>Legal</h4>
                        <ul>
                            <li><a href="https://google.com">Terms</a></li>
                            <li><a href="https://google.com">Privacy</a></li>
                            <li><a href="https://google.com">Copyright</a></li>
                            <li><a href="https://google.com">Cookie Preferences</a></li>
                        </ul>
                    </div>

                    <div className="web-footer-primary__column">
                        <h4>Social</h4>
                        <ul>
                            <li><a href="https://google.com">
                                <img className="footer__social__img" src="images\instagram-brands.svg" alt="Instagram" />
                                Instagram
                            </a></li>
                            <li><a href="https://google.com">
                                <img className="footer__social__img" src="images\twitter-brands.svg" alt="Instagram" />
                                Twitter
                            </a></li>
                            <li><a href="https://google.com">
                                <img className="footer__social__img" src="images\facebook-brands.svg" alt="Instagram" />
                                Facebook
                            </a></li>
                            <li><a href="https://google.com">
                                <img className="footer__social__img" src="images\pinterest-brands.svg" alt="Instagram" />
                                Pinterest
                            </a></li>
                        </ul>
                    </div>

                    <div className="web-footer-primary__column">
                        <h4>Get our free apps</h4>
                        <ul>
                            <li><a href="https://google.com"><img className="footer__logo__appstore" src="images\appstore_white.svg" alt="Appstore" /></a></li>
                            <li><a href="https://google.com"><img className="footer__logo__playstore" src="images\playstore.svg" alt="Playstore" /></a></li>
                        </ul>
                    </div>
                </div>
            </div>


            <div className="footer-container-divider">
                <div className="container container-divider"></div>
            </div>
        </>
    )
}

export default FooterPrimary;